import React from 'react'

import { Box, Typography } from "@mui/material"


export default function ownerColumn() {

	return {
		name: 'isCompanyName',
		label: 'Owner',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", ml: 1 }}>
				<Typography>{value || "Any"}</Typography>
			</Box>,
		}
	}
}